<template>
  <div
    id="app"
    class="h-screen bg-grey"
  >
    <header-bar />
    <div
      id="header-spacer"
      class="w-full min-h-75p h-1/6 "
    />
    <router-view />
  </div>
</template>
<script>

import HeaderBar from './components/HeaderBar.vue'
export default {
  components: { HeaderBar },
}
</script>
<style lang="postcss">
h1,
h2,
h3,
h4,
h5,
h6,
p {
  @apply text-white;
}
.btn {
  @apply bg-primary rounded-lg text-sm sm:text-lg p-2 sm:px-5 text-white h-12 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed;
}
</style>
